import { ImmutSet } from '@eturi/util'
import lodashSize from 'lodash/size'

// FIXME: Move to @eturi/util and add spec
export const size = (v: object | string | null | undefined) =>
	v instanceof ImmutSet ? v.size : lodashSize(v)
